import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Summary } from './Summary'
import { List, ListPlaceholder, ListEmpty } from './List'
import slugify from 'react-slugify'
import { withLastLocation } from 'react-router-last-location'

import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'

import Helmet from 'react-helmet'

import '@loyal_template/cart.css'
import { Alert } from 'loyal-react'

class Cart extends Component {
  constructor (props) {
    super(props)
    this.state = {
      sendGTM: false,
      errorShipping: false
    }

    this.sendGTM = this.sendGTM.bind(this)
  }

  componentDidMount () {
    let element = document.getElementById('go-to-main-content')
    if (element) {
      document.getElementById('go-to-main-content').focus()

      setTimeout(() => {
        document.activeElement.blur()
      }, 500)
    }

    this.props.fetchCart()
    this.props.resetShipping()
    this.props.clearConfirmedOrderData()
    this.sendETMC()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.shipping !== this.props.shipping) {
      if (this.props.shipping && this.props.shipping.error) {
        this.setShippingError()
      }
    }
  }
  setShippingError = () => {
    this.setState({ errorShipping: true })
  }
  clearError = () => {
    this.setState({ errorShipping: false })
  }
  sendGTM () {
    const props = this.props

    if (Object.entries(props.items).length > 0) {
      this.setState({ sendGTM: true })
      const productsList = []

      props.items.map((item, index) => {
        let categoryName
        if (item.category) {
          categoryName = item.category.name !== '' ? slugify(item.category.name, { delimiter: ' ' }) : undefined
        }
        return (

          productsList.push({
            'name': slugify(item.name, { delimiter: ' ' }),
            'id': item.sku,
            'price': item.price,
            'brand': undefined,
            'category': categoryName,
            'variant': undefined,
            'quantity': item.quantity,
            'coupon': undefined,
            'dimension5': item.vendor ? 'vendor-' + item.vendor.id : undefined,
            'metric2': item.cash ? item.cash.sellingPrice.toFixed(2) : undefined
          })
        )
      })

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'checkout',
        'eventCategory': 'enhanced-ecommerce',
        'eventAction': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': '1' },
            'products': productsList
          }
        }
      })
    }
  }

  sendETMC () {
    const props = this.props

    if (Object.entries(props.items).length > 0) {
      const productsList = []

      props.items.map((item, index) => {
        return (
          productsList.push({
            'item': item.sku,
            'quantity': 999999,
            'price': item.price,
            'unique_id': item.sku
          })
        )
      })
      window._etmc.push(['setOrgId', '6422293'])
      window._etmc.push(['trackConversion', { 'cart': productsList }])
    }
  }
  render () {
    const ready = !this.props.isLoading || this.props.wasModified
    const { shipping } = this.props
    const showErrorShipping = this.state.errorShipping && (shipping && shipping.error)

    if (this.state.sendGTM === false) {
      this.sendGTM()
    }

    this.sendETMC()

    if (this.props.items.length < 1 && ready) {
      return (
        <Fragment>
          <Helmet>
            <title>{`Seu carrinho está vazio - ${process.env.REACT_APP_TITLE || ''}`}</title>
          </Helmet>
          <div className='container-cart container py-0 container-fluid mt-3 mt-sm-5'>
            <div className='row py-0 py-md-0 mt-0'>
              <div className='col-12'>
                <div className='row py-0 py-md-0 mt-0 mt-md-0'>
                  <ListEmpty />
                  <Summary {...this.props} ready={ready} />
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )
    }

    return (
      <Fragment>
        <Helmet>
          <title>{`Seu carrinho - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-cart container py-0 container-fluid mt-3 mt-sm-5'>
          {
            this.props.errorData &&
            this.props.errorData.message &&
            this.props.errorData.statusCode !== 406 &&
            (
              <Alert
                isError
                title={this.props.errorData.message}
                description={this.props.errorData.subMessage || 'Por favor tente novamente em instantes.'}
                className='pb-2'
                onClose={() => this.props.clearCartError()}
              />
            )
          }
          <div className='pt-1 pt-md-0'>
            <div className='row py-0 py-md-0 mt-0'>
              { showErrorShipping ? <Alert
                isError
                title={shipping.error}
                description={shipping.errorSub}
                className='pb-2'
                onClose={() => this.clearError()}
              /> : '' }
              <ReactPlaceholder
                ready={ready}
                customPlaceholder={<ListPlaceholder />}
              >
                <List {...this.props} sendGTM={this.sendGTM} />
              </ReactPlaceholder>
              <Summary {...this.props} ready={ready} />
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

Cart.propTypes = {
  id: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  wasModified: PropTypes.bool.isRequired,
  isUpdating: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  shipping: PropTypes.object.isRequired,
  fetchCart: PropTypes.func.isRequired,
  stores: PropTypes.array.isRequired,
  resetShipping: PropTypes.func.isRequired,
  lastLocation: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string
  }),
  clearConfirmedOrderData: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  statusCode: PropTypes.string,
  clearCartError: PropTypes.func,
  handleZipCodeHasValid: PropTypes.func,
  errorData: PropTypes.object,
  history: PropTypes.object
}

export default withLastLocation(Cart)



// WEBPACK FOOTER //
// ./src/features/Cart/Cart.js